import { collection, doc, getDoc, getDocs, orderBy, query, setDoc, where } from "firebase/firestore";
import { storageF } from "../firebase.config";
import { DateTime } from "luxon";
import { db } from "../firebase.config";
import { categoryType, infoType, clientType, option, optionType, OrderType, productType, openHour, benefitType } from "./types";
import { getDownloadURL } from "@firebase/storage";
import { ref } from "firebase/storage";
import { clientId } from "../recoil/Selectors";

export const WppMsj = (text: string, wpp: string) => {
    const url = `https://api.whatsapp.com/send?phone=${wpp}&text=${encodeURIComponent(text)}`;
    return url;
}

export const WppUri = (text: string, wpp: string) => {
    const url = `whatsapp://send/?phone=${wpp}&text=${encodeURIComponent(text)}`;
    return url;
}

export const NavigateTo = (url: string, targetBlank?: boolean) => {
    window.open(url, targetBlank ? '_blank' : "_self");
}


const getOptionsProduct = (product: option[]) => {
    const selectedOptions = product.map((option) => {
        return `${option.name}: ${option.value}`;
    });
    return selectedOptions;
};



export const productMsj = (item: productType) => {

    const name = `• ${item.name}`;
    const qty = item.qty && item.qty > 1 && item.qty;
    const qtyText = qty ? `(x${qty})` : "";
    const options = item.options && item.selectedOptions ? ` - (${getOptionsProduct(item.selectedOptions!)})` : "";
    const price = qty ? ` - $${item.price *= qty}` : ` - $${item.price}`

    const productMsj = name + qtyText + options + price
    return productMsj;
}

export const fetchOrder = async (id:string) => {
    const docRef = doc(db, "jdays-orders", id);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      console.log("Document data:", docSnap.data());
      return docSnap.data() as OrderType
    } else {
      // doc.data() will be undefined in this case
      console.log("No such document!");
    }
};



export const generateMsjOrder = (order: OrderType) => {
    const msj = `🛎 Pedido Nuevo: 
    ${order.info.name} 
    ${order.info.type === "delivery" ? "🛵 Delivery" : "🚶‍♂️ Retiro"} 
    ${order.info.address && order.info.address}
    +598 ${order.info.phone} 
    Paga con: ${order.info.payment}
    ${order.info.notes && `notas: ${order.info.notes}`}
    
    Productos: 
    ${order.cart.map((item) => {
        return `${productMsj(item)}
         `
    })}
      
    Total: $${order.total}
    
    `;
    return msj;
}

export const UseGenerateDates = () => {
    const dateNow = DateTime.local()

    const dateStart = dateNow
    const dateEstimated = dateNow.plus({ minutes: 45 });

    return [dateStart.toJSDate(), dateEstimated.toJSDate()]
}

export const generateOrder = (data: infoType, cart: productType[], total: number) => {

    const [dateStart, dateEstimated] = UseGenerateDates();

    const newOrder: OrderType = {
        info: data,
        date: dateStart,
        date_estimated: dateEstimated,
        cart: cart,
        total: total,
        status: "completed",
    }

    return newOrder;
}

export const getLastOrder = () => {
    const lastOrder: OrderType | null = JSON.parse(localStorage.getItem("lastOrder")!);
    return lastOrder;
}

export const lastOrderExists = () => {
    const lastOrder: OrderType = JSON.parse(localStorage.getItem("lastOrder")!);

    return lastOrder ? true : false;
}

export const lastOrderActive = () => {

    const lastOrder = getLastOrder()

    if (lastOrder) {
        const date_estimated = DateTime.fromJSDate(new Date(lastOrder.date_estimated))
        const orderActive = DateTime.fromJSDate(new Date()) < date_estimated ? true : false
        return orderActive ? orderActive : false;
    }

    else {
        return false
    }

}

export const uploadOrder = async (order: OrderType) => {
    const uploadOrderRef = doc(collection(db, `${clientId}-orders`));
    const response2 = await setDoc(uploadOrderRef, { ...order, id: uploadOrderRef.id, });
    return response2
}

export const sendInterest = async (formData: any) => {
    const uploadFormRef = doc(collection(db, `interested`));
    const response2 = await setDoc(uploadFormRef, { ...formData, date: new Date()});
    return response2
}

export const uploadInfo = async (info: clientType) => {
    await setDoc(doc(db, `info`, info.slug), info);
}


export const getImageUrl = async (dir: string) => {

    try {
        const storageRef = ref(storageF, `${clientId}/${dir}`)
        const url = await getDownloadURL(storageRef)
        return url
    }

    catch (e) {
        console.log(e);
        return ""
    }
}

export const applyDescount = (product: productType) =>{
    var price = product.price
    var discount = product.discount! / 100
    var price_dis = Math.round(price - (price * discount))

    return {...product, price: price_dis, priceDiscounted: price} as productType
}


export const fetchMenu = async () => {
    const productsAvaliable = await query(collection(db, `${clientId}-menu`), where("visible", "==", true));
    const data = await getDocs(productsAvaliable);
    const productsTyped = data.docs.map(x => x.data() as productType)
    
    const applyDiscounts = productsTyped.map((item) =>{
        return item.discount ? applyDescount(item) : item
    })

    return applyDiscounts
};

export const fetchBenefits = async () => {
    const benefitsByTenant = await query(collection(db, `benefits`), where("tenant", "==", clientId));
    const data = await getDocs(benefitsByTenant);
    const benefitsTyped = data.docs.map(x => x.data() as benefitType)
    
    return benefitsTyped
};

export const fetchReccomended = async () => {
    const reccomenedRef = collection(db, `${clientId}-menu`);
    const qry = await query(reccomenedRef, where("featured", "==", true));
    const data = await getDocs(qry);
    const productsTyped = data.docs.map(x => x.data() as productType)
    return productsTyped
};

export const fetchCategories = async () => {
    const categoriesRef = collection(db, `${clientId}-categories`);
    const qry = await query(categoriesRef, orderBy("order", "asc"));
    const data = await getDocs(qry);
    const categoriesTyped = data.docs.map(x => x.data() as categoryType)
    return categoriesTyped
};

export const fetchInfo = async (clientId: string) => {
    const docRef = doc(db, "info", clientId);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
        return docSnap.data() as clientType
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
    }
};

export const isClosed = (weekDays: openHour[]) => {
    var d = new Date();
    var n = d.getDay();
    var now = parseFloat(d.getHours() + "." + ('0' + d.getMinutes()).slice(-2));
    var weekdays = weekDays
    var day = weekdays[n];
    if (now < 1) {
        now = now + 24;
    }

    let times = day.times.map((item) => {
        if (item < 1) { return item = item + 24 }
        else {
            return item
        }
    })

    // eslint-disable-next-line no-mixed-operators
    if (now >= times[0] && now < times[1] || now >= times[2] && now < times[3]) {
        return false
    }
    else {
        return true
    }
}

export const convertToSlug = (text: string) => {
    return text
        .toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '');
}

export const formatMenuJD2BM = (list: any[]) => {
    const formated: productType[] = list.map((item) => {
        const itemF: productType = {
            name: item.name,
            description: item.description,
            slug: convertToSlug(item.name),
            price: item.price_dis ? item.price_dis : item.base_price,
            image: item.picture,
            category: item.category,
            discount: item.category !== "Bebidas" ? 10 : undefined
        }
        return itemF
    })

    return formated
}

export const updatePizzas = async (productsFetch: productType[]) => {

    const optionsForPizzas: optionType[] = [
        {
            "name": "Tamaño",
            "optionItems": [
                {
                    "price": 0,
                    "name": "32cm"
                },
                {
                    "price": 100,
                    "name": "42cm"
                }
            ],
            "multiple": false,
            "required": true
        }
    ]

    const pizzasWithOptions = productsFetch.forEach(async (product) => {
        if (product.category === "pizzas") {
            await setDoc(doc(db, `${clientId}-menu`, product.slug), { ...product, options: optionsForPizzas });
        }
    })
}

export const createProduct = async (product: productType) => {

    const Pizzas = ["Cuatro Quesos",
    "BBQ chicken bacon",
    "De La Huerta",
    "Deliciosa",
    "Forte",
    "Siesta",
    "Killer",
    "Cheese",
    "Capresse",
    "Hawaiana",
    "Oliva",
    "Peroni",
    "Tomatito",
    "Paprika lovers"]

    const pizzasOptions = Pizzas.map((item) => ({"price": 0,"name": item,}))

    const optionsForPizzas: optionType[] = [

        {
            "name": "Proteina",
            "optionItems": [
                {
                    "price": 0,
                    "name": "Carne"
                },
                {
                    "price": 0,
                    "name": "Pollo"
                }
            ],
            "multiple": false,
            "required": true
        },
        {
            "name": "Guarnición",
            "optionItems": [
                {
                    "price": 0,
                    "name": "Papas Fritas"
                },
                {
                    "price": 0,
                    "name": "Aros de Cebolla"
                },
                {
                    "price": 0,
                    "name": "Mix Papas y Boniatos"
                }
            ],
            "multiple": false,
            "required": false,
        }
        
    ]

    return await setDoc(doc(db, `${clientId}-menu`, product.slug), { ...product, options: optionsForPizzas });
}

export const customPizza = async () => {

    const optionsForPizzas: optionType[] = [
        {
            "name": "Tamaño",
            "optionItems": [
                {
                    "price": 0,
                    "name": "32cm"
                },
                {
                    "price": 100,
                    "name": "42cm"
                }
            ],
            "multiple": false,
            "max": 10,
            "required": true
        },
        {
            "name": "Quesos",
            "optionItems": [
                {
                    "price": 20,
                    "name": "Queso Crema"
                },
                {
                    "price": 20,
                    "name": "Cheddar"
                },
                {
                    "price": 20,
                    "name": "Blue Cheese"
                },
                {
                    "price": 20,
                    "name": "Parmesano"
                },
                {
                    "price": 20,
                    "name": "Provolone"
                },
            ],
            "multiple": true,
            "max": 10,
            "required": false
        },
        {
            "name": "Carnes",
            "optionItems": [
                {
                    "price": 20,
                    "name": "Pollo"
                },
                {
                    "price": 20,
                    "name": "Panceta"
                },
                {
                    "price": 20,
                    "name": "Jámon"
                },
                {
                    "price": 20,
                    "name": "Pepperoni"
                },
            ],
            "multiple": true,
            "max": 10,
            "required": false
        },
        {
            "name": "Vegetales",
            "optionItems": [
                {
                    "price": 20,
                    "name": "Cebolla"
                },
                {
                    "price": 20,
                    "name": "Tomate"
                },
                {
                    "price": 20,
                    "name": "Hongos"
                },
                {
                    "price": 20,
                    "name": "Pimientos Verdes"
                },
                {
                    "price": 20,
                    "name": "Pimientos Rojos"
                },
                {
                    "price": 20,
                    "name": "Aceitunas"
                },
                {
                    "price": 20,
                    "name": "Rúcula"
                },
                {
                    "price": 20,
                    "name": "Albahaca"
                },
            ],
            "multiple": true,
            "max": 10,
            "required": false
        },
        {
            "name": "Otros",
            "optionItems": [
                {
                    "price": 20,
                    "name": "Huevos Fritos"
                },
                {
                    "price": 20,
                    "name": "Pera"
                },
                {
                    "price": 20,
                    "name": "Papas Pay"
                },
                {
                    "price": 20,
                    "name": "Piña"
                },
            ],
            "multiple": true,
            "max": 10,
            "required": false
        },
        {
            "name": "Extra",
            "optionItems": [
                {
                    "price": 30,
                    "name": "Extra Alioli (Dip)"
                },
                {
                    "price": 90,
                    "name": "Extra Muzzarella"
                },
            ],
            "multiple": true,
            "max": 10,
            "required": false
        },
    ]

    const productN: productType = {
        "visible": true,
        "category": "pizzas",
        "name": "Crea tu Pizza",
        "price": 420,
        "description": "Crea tu propia pizza, elige tus ingredientes favoritos.",
        "discount": 0,
        "options": optionsForPizzas,
        "image": "",
        "slug": "crear-pizza"
    }

    await setDoc(doc(db, `${clientId}-menu`, productN.slug), productN);
}

export const customBurger = async () => {

    const optionsForBurgers: optionType[] = [
        {
            "name": "Toppings",
            "optionItems": [
                {
                    "price": 0,
                    "name": "Lechuga"
                },
                {
                    "price": 0,
                    "name": "Tomate"
                },
                {
                    "price": 0,
                    "name": "Cebolla"
                },
                {
                    "price": 0,
                    "name": "Pepinillos"
                },
            ],
            "multiple": true,
            "max": 10,
            "required": false
        },
        {
            "name": "Aderezos",
            "optionItems": [
                {
                    "price": 0,
                    "name": "Ketchup"
                },
                {
                    "price": 0,
                    "name": "Mostaza"
                },
                {
                    "price": 0,
                    "name": "Mayonesa"
                },
                {
                    "price": 0,
                    "name": "BBQ"
                },
                {
                    "price": 0,
                    "name": "Sweet Chilly"
                },
            ],
            "multiple": true,
            "max": 10,
            "required": false
        },
        {
            "name": "Extras",
            "optionItems": [
                {
                    "price": 80,
                    "name": "Extra Carne"
                },
                {
                    "price": 40,
                    "name": "Extra Cheddar"
                },
                {
                    "price": 40,
                    "name": "Extra Huevo Frito"
                },
                {
                    "price": 40,
                    "name": "Papas Pay"
                },
            ],
            "multiple": true,
            "max": 10,
            "required": false
        },
    ]

    const productN: productType = {
        "category": "burgers",
        "slug": "crear-burger",
        "name": "Crea tu Burger",
        "description": "Selecciona tus ingredientes",
        "image": "",
        "discount": 0,
        "visible": true,
        "price": 261,
        options: optionsForBurgers
    }

    await setDoc(doc(db, `${clientId}-menu`, productN.slug), productN);
}

export const duplicate = async (from: string, to: string, slug: string, newSlug: string) => {
    const docRef = doc(db, from, slug);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        //return docSnap.data() as clientType

        await setDoc(doc(db, to, newSlug), { ...docSnap.data(), slug: newSlug, options: null, tenant: clientId });
        //return docSnap.data() as clientType
    } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
    }
};